import PropTypes from 'prop-types';
import React, { Component } from 'react';

import getConfig from 'Util/Config';
import FormGenerator from 'Components/Form/FormGenerator';

import { FILE_TYPE, SHIPMENT_PROVIDERS_OPTIONS } from '../../common';

import FileUploadInput from './FileUploadInput';

const config = getConfig();
const getFields = (type, skuData) => {
  const fields = [
    {
      inputType: FormGenerator.INPUT_TYPE.TEXT_FIELD,
      inputLabel: 'Code',
      inputName: 'fileCode',
      inputProps: {
        required: true,
      },
    },
  ];
  if (type === FILE_TYPE.NEW_DISCOUNT_CODE) {
    fields.push({
      inputType: FormGenerator.INPUT_TYPE.DROPDOWN,
      inputLabel: 'SKUCodes',
      inputName: 'SKUIds',
      options: skuData.map(({ id, SKUCode }) => ({
        text: SKUCode,
        value: id,
        key: id,
      })),
      inputProps: {
        multiple: true,
      },
    });
  }
  if (
    type === FILE_TYPE.SHIPMENT_REPORTS &&
    config.fileImport.enabledShipmentTrackingShipmentProvider
  ) {
    fields.push({
      inputType: FormGenerator.INPUT_TYPE.DROPDOWN,
      inputLabel: 'Shipment Provider',
      inputName: 'shipmentProvider',
      options: SHIPMENT_PROVIDERS_OPTIONS,
    });
  }
  fields.push({
    inputType: FormGenerator.INPUT_TYPE.CUSTOM_TYPE,
    inputLabel: 'File',
    inputName: 'file',
    inputProps: {
      required: true,
    },
    customInput: (props) => <FileUploadInput type={type} {...props} />,
  });
  return fields;
};

export default class DataForm extends Component {
  static propTypes = {
    onCreateNewData: PropTypes.func,
    isEdit: PropTypes.bool,
    type: PropTypes.oneOf(Object.values(FILE_TYPE)).isRequired,
    skuData: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        SKUCode: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    onCreateNewData: () => {},
    isEdit: false,
    skuData: [],
  };

  handleSubmit = (form) => {
    this.props.onCreateNewData(form);
  };

  render() {
    const { isEdit, type, skuData } = this.props;
    return (
      <FormGenerator
        fields={getFields(type, skuData)}
        onSubmit={this.handleSubmit}
        submitText={isEdit ? 'Update' : 'Add'}
        cancelText="Cancel"
        showCancel
        {...this.props}
      />
    );
  }
}
